<template>
  <div class="main">
    <div class="header">
      <i :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'" class="collapse-btn" @click="toggleCollapse"></i>
      <div class="head_left"></div>
      <div class="head_right">
        <span>你好，{{ userName }}</span>
        <el-link @click="logOut" class="exit" type="warning">退出</el-link>
      </div>
    </div>
    <div class="content">
      <div class="content-left" :class="{ collapsed: isCollapse }">
        <el-menu :default-active="activeMenuIndex" :collapse="isCollapse" :collapse-transition="false"
          class="heightP100 home-menu">
          <el-menu-item v-for="menu in filteredMenus" :key="menu.index" :index="menu.index" class="my-el-menu"
            @click="$router.push(menu.path)">
            <i :class="menu.icon" v-if="menu.icon"></i>
            <span slot="title" class="collapse-submenu-text">{{ menu.name }}</span>
          </el-menu-item>
        </el-menu>
      </div>
      <div class="content-main" :class="{ expanded: isCollapse }">
        <div class="div-router">
          <transition name="move" mode="out-in">
            <router-view :key="key"></router-view>
          </transition>
        </div>
      </div>
    </div>

    <!-- <div class="footer">
      <span class="marginL200 floatL fontSize13">
        {{ year1 }}年{{ month1 }}月{{ date1 }}日 {{ time }} {{ day1 }}</span
      >
      <span class="center fontSize13">
        【版本号】V1.0.0
      </span>
    </div> -->
  </div>
</template>

<script>
import utils from "../lib/utils";

export default {
  name: "Home",
  data() {
    return {
      msg: "Welcome to homeeeeeeeeeeeeeeee",
      userName: "fff",
      defaultActiveMenu: "-1", // 默认选中的菜单
      day1: "",
      year1: "",
      month1: "",
      date1: "",
      time: "",
      userRole: "",
      userPermissions: [],
      isCollapse: false
    };
  },
  computed: {
    key() {
      const path = this.$route.path;
      if (path.startsWith('/token/') || path.startsWith('/stats/')) {
        return '/report';
      }
      return path;
    },
    // 计算当前选中的菜单索引
    activeMenuIndex() {
      const currentPath = this.$route.path;
      const menu = this.filteredMenus.find(m => m.path === currentPath);
      return menu ? menu.index : '';
    },
    filteredMenus() {
      const homeRoute = this.$router.options.routes.find(r => r.path === '/home');
      if (!homeRoute || !homeRoute.children) return [];

      return homeRoute.children
        .filter(route => {
          if (!route.meta || !route.meta.roles || route.meta.roles.length === 0) {
            return true;
          }
          return route.meta.roles.includes(this.userRole);
        })
        .map((route, index) => ({
          index: `0-${index + 1}`,
          path: route.path,
          name: route.meta && route.meta.title ? route.meta.title : route.name,
          icon: route.meta && route.meta.icon ? route.meta.icon : ''
        }));
    }
  },
  methods: {
    gettime() {
      // 获取实时时间
      var weekday = new Array(7);
      weekday[0] = "星期日";
      weekday[1] = "星期一";
      weekday[2] = "星期二";
      weekday[3] = "星期三";
      weekday[4] = "星期四";
      weekday[5] = "星期五";
      weekday[6] = "星期六";

      var today = new Date();
      var h = today.getHours();
      var m = today.getMinutes();
      var s = today.getSeconds();
      var d = today.getDate();
      var mo = today.getMonth();
      var ye = today.getFullYear();
      var da = today.getDay();
      if (h < 10) {
        h = "0" + h;
      }
      if (m < 10) {
        m = "0" + m;
      }
      if (s < 10) {
        s = "0" + s;
      }
      this.time = h + ":" + m + ":" + s;
      this.date1 = d;
      this.month1 = mo + 1;
      this.year1 = ye;
      this.day1 = weekday[da];
    },
    logOut() {
      this.$confirm("确认退出?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          utils.delCookie("tamc_token");
          localStorage.removeItem("userName");
          this.$router.push("/login");
        })
        .catch(() => { });
    },
    toggleCollapse() {
      this.isCollapse = !this.isCollapse;
    }
  },

  created() {
    this.userName = localStorage.getItem("userName");
    setInterval(this.gettime, 1000);

    // 获取用户权限信息
    this.userRole = localStorage.getItem("userRole") || "";
    // try {
    //   const permissionsStr = localStorage.getItem("userPermissions");
    //   this.userPermissions = permissionsStr ? JSON.parse(permissionsStr) : [];
    // } catch (e) {
    //   this.userPermissions = [];
    // }
  }
};
</script>

<style scoped>
@import "../assets/css/home.scss";
@import "../assets/css/index.scss";
</style>

<style>
/* 折叠菜单 tooltip 宽度调整 - tooltip popover 挂载到 body，必须用全局样式 */
.el-tooltip__popper {
  max-width: 80px !important;
  min-width: 40px !important;
  width: auto !important;
  padding: 8px 14px !important;
  font-size: 13px !important;
  line-height: 1.4 !important;
}

.el-tooltip__popper.is-dark {
  background-color: #303133 !important;
}

.el-tooltip__popper.is-dark[x-placement^="right"] .popper__arrow::after {
  border-right-color: #303133 !important;
}
</style>
